import startCase from "lodash.startcase";
import { DateTime } from "luxon";
import React from "react";

import { IgChip } from "@intelligems/ig-theme";
import { StripeSubscriptionStatus } from "@intelligems/ig-types";
import { ChipPropsColorOverrides } from "@mui/material/Chip/Chip";
import { OverridableStringUnion } from "@mui/types";

interface StatusBadgeProps {
  status: StripeSubscriptionStatus;
  cancelAt?: number | null | undefined;
}

const Text: Partial<Record<StripeSubscriptionStatus, string>> = {
  cancelled: "Cancelled",
  canceled: "Cancelled",
};

const Color: Record<
  StripeSubscriptionStatus,
  OverridableStringUnion<
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning",
    ChipPropsColorOverrides
  >
> = {
  active: "success",
  pending: "secondary",
  cancelled: "error",
  canceled: "error",
  trialing: "info",
  past_due: "error",
  incomplete: "warning",
  incomplete_expired: "warning",
  paused: "secondary",
  unpaid: "error",
};

export const StatusBadge = ({ status, cancelAt }: StatusBadgeProps) => {
  return (
    <IgChip
      label={
        cancelAt
          ? `Pending Cancellation ${DateTime.fromSeconds(cancelAt).toFormat("yyyy-MM-dd")}`
          : Text[status] || startCase(status)
      }
      color={Color[cancelAt ? "cancelled" : status] || "secondary"}
      size={"small"}
    />
  );
};
